import React from "react";
import { MDBModal, MDBModalBody } from "mdbreact";
import styles from "./style.module.scss";

class ModalConfirmCashierBooking extends React.Component {
  formatCurrency = amount => {
    if (!amount) return "0";
    return new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND"
    }).format(amount);
  };

  render() {
    const { isOpen, toggle, patient, data, confirmAction } = this.props;

    return (
      <MDBModal isOpen={isOpen} toggle={toggle} className={styles.confirmModal}>
        <MDBModalBody className={styles.modalBodyCashier}>
          <div className={styles.content}>
            <div className={styles.header}>
              <h4>Xác nhận thu tiền mặt</h4>
            </div>

            <div className={styles.patientInfo}>
              <p>
                <strong>Bệnh nhân:</strong>
                <span>{patient?.surname + " " + patient?.name}</span>
              </p>
              <p>
                <strong>Số tiền cần thu:</strong>
                <span>{this.formatCurrency(data?.amount)}</span>
              </p>
            </div>

            <div className={styles.modalActions}>
              <button onClick={toggle} className={styles.cancelButton}>
                <span>Đóng</span>
              </button>
              <button onClick={confirmAction} className={styles.confirmButton}>
                <span>Xác nhận thu tiền</span>
              </button>
            </div>
          </div>
        </MDBModalBody>
      </MDBModal>
    );
  }
}

export default ModalConfirmCashierBooking;
